import * as actionTypes from '../actions/actionTypes'

const initialState = {
  records: [],
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 0,
    from: 0,
    to: 0
  },
  filtered: null,
  imported: false,
  importLoading: false,
  downloading: false,
  appraisalTypes: [],
  filterCompanies: [],
  filterForms: [],
  filterStructure: [],
  filterOrgLevelGroups: [],
  filterOrgs: [],
  filterStatus: [],
  // filterCriteria: [],
  recordsLoading: false,
  filterLoadingQueue: [],
  toStageList: null,
  bulkUpdateSuccess: false
}

const fetchAppraisalTypeOptionsStart = (state, action) => {
  return {
    ...state
  }
}

const fetchAppraisalTypeOptionsSuccess = (state, action) => {
  return {
    ...state,
    appraisalTypes: action.data.map(item => {
      return {
        appraisal_type_id: item.value_list_id,
        appraisal_type_code: item.value_list_code,
        appraisal_type_name: item.value_list_name
      }
    })
  }
}

const fetchAppraisalTypeOptionsFailed = (state, action) => {
  return {
    ...state
  }
}

const fetchCompanyOptionsStart = (state, action) => {
  return { ...state, filterLoadingQueue: [...state.filterLoadingQueue, 'company_id'] }
}

const fetchCompanyOptionsSuccess = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'company_id'),
    filterCompanies: action.data
  }
}

const fetchCompanyOptionsFailed = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'company_id')
  }
}

const fetchFormOptionsStart = (state, action) => {
  return { ...state, filterLoadingQueue: [...state.filterLoadingQueue, 'form_id'] }
}

const fetchFormOptionsSuccess = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'form_id'),
    filterForms: action.data
  }
}

const fetchFormOptionsFailed = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'form_id')
  }
}

const fetchStructureOptionsStart = (state, action) => {
  return { ...state, filterLoadingQueue: [...state.filterLoadingQueue, 'structure_id'] }
}

const fetchStructureOptionsSuccess = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'structure_id'),
    filterStructure: action.data
  }
}

const fetchStructureOptionsFailed = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'structure_id')
  }
}

// const fetchCriteriaOptionsStart = (state, action) => {
//   return { ...state, filterLoadingQueue: [...state.filterLoadingQueue, 'company'] }
// }

// const fetchCriteriaOptionsSuccess = (state, action) => {
//   return { ...state, filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'company'), filterCriteria: action.data }
// }

// const fetchCriteriaOptionsFailed = (state, action) => {
//   return { ...state, filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'company') }
// }

const fetchOrgLevelGroupOptionsStart = (state, action) => {
  return { ...state, filterLoadingQueue: [...state.filterLoadingQueue, 'level_group_id'] }
}

const fetchOrgLevelGroupOptionsSuccess = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'level_group_id'),
    filterOrgLevelGroups: action.data
  }
}

const fetchOrgLevelGroupOptionsFailed = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'level_group_id')
  }
}

const fetchOrganizationOptionsStart = (state, action) => {
  return { ...state, filterLoadingQueue: [...state.filterLoadingQueue, 'org_id'] }
}

const fetchOrganizationOptionsSuccess = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'org_id'),
    filterOrgs: action.data
  }
}

const fetchOrganizationOptionsFailed = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'org_id')
  }
}

const fetchStatusOptionsStart = state => {
  return {
    ...state,
    filterLoadingQueue: [...state.filterLoadingQueue, 'status_id']
  }
}

const fetchStatusOptionsSuccess = (state, action) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'status_id'),
    filterStatus: action.data
  }
}

const fetchStatusOptionsFailed = state => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'status_id')
  }
}

const fetchAssignmentsStart = (state, action) => {
  return {
    ...state,
    recordsLoading: true
  }
}

const fetchAssignmentsSuccess = (state, action) => {
  if (action.appraisalType !== 'corporate') {
    return {
      ...state,
      recordsLoading: false
    }
  }
  return {
    ...state,
    recordsLoading: false,
    filtered: action.filterOptions,
    records: action.records,
    pagination: action.pagination
  }
}

const fetchAssignmentsFailed = (state, action) => {
  return {
    ...state,
    recordsLoading: false,
    filtered: action.filterOptions
  }
}

const importAssignmentStart = (state, action) => {
  return {
    ...state,
    importLoading: true,
    imported: false
  }
}

const deleteAssignmentStart = (state, action) => {
  return {
    ...state,
    recordsLoading: true
  }
}

const deleteAssignmentSuccess = (state, action) => {
  return {
    ...state,
    recordsLoading: false
  }
}

const deleteAssignmentFailed = (state, action) => {
  return {
    ...state,
    recordsLoading: false
  }
}

const importAssignmentSuccess = (state, action) => {
  return {
    ...state,
    importLoading: false,
    imported: true
  }
}

const importAssignmentFailed = (state, action) => {
  return {
    ...state,
    importLoading: false,
    imported: false
  }
}

const exportAssignmentStart = (state, action) => {
  return {
    ...state,
    downloading: true
  }
}

const exportAssignmentSuccess = (state, action) => {
  return {
    ...state,
    downloading: false
  }
}

const exportAssignmentFailed = (state, action) => {
  return {
    ...state,
    downloading: false
  }
}

const clearCorporateAssignmentRecord = state => {
  return {
    ...state,
    records: [],
    // filtered: false,
    pagination: {
      total: 0,
      perPage: 10,
      currentPage: 0,
      lastPage: 0,
      from: 0,
      to: 0
    }
  }
}

const fetchToStageStart = state => {
  return { ...state, filterLoadingQueue: [...state.filterLoadingQueue, 'stage_id'] }
}

const fetchToStageSuccess = (state, { toStageList }) => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'stage_id'),
    toStageList: toStageList
  }
}

const fetchToStageFailed = state => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'stage_id')
  }
}

const bulkUpdateAssignmentStart = state => {
  return {
    ...state,
    filterLoadingQueue: [...state.filterLoadingQueue, 'bulkUpdateAssignment'],
    bulkUpdateSuccess: false
  }
}

const bulkUpdateAssignmentSuccess = state => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'bulkUpdateAssignment'),
    bulkUpdateSuccess: true
  }
}

const bulkUpdateAssignmentFailed = state => {
  return {
    ...state,
    filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'bulkUpdateAssignment'),
    bulkUpdateSuccess: false
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_START:
      return fetchAppraisalTypeOptionsStart(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_SUCCESS:
      return fetchAppraisalTypeOptionsSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FAILED:
      return fetchAppraisalTypeOptionsFailed(state, action)

    case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_START:
      return fetchCompanyOptionsStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchCompanyOptionsSuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchCompanyOptionsFailed(state, action)

    case actionTypes.FETCH_FORM_OPTIONS_START:
      return fetchFormOptionsStart(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_SUCCESS:
      return fetchFormOptionsSuccess(state, action)
    case actionTypes.FETCH_FORM_OPTIONS_FAILED:
      return fetchFormOptionsFailed(state, action)

    case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_START:
      return fetchStructureOptionsStart(state, action)
    case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchStructureOptionsSuccess(state, action)
    case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchStructureOptionsFailed(state, action)

    // case actionTypes.FETCH_CRITERIA_OPTIONS_START:
    //   return fetchCriteriaOptionsStart(state, action)
    // case actionTypes.FETCH_CRITERIA_OPTIONS_SUCCESS:
    //   return fetchCriteriaOptionsSuccess(state, action)
    // case actionTypes.FETCH_CRITERIA_OPTIONS_FAILED:
    //   return fetchCriteriaOptionsFailed(state, action)

    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_START:
      return fetchOrgLevelGroupOptionsStart(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchOrgLevelGroupOptionsSuccess(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchOrgLevelGroupOptionsFailed(state, action)

    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START:
      return fetchOrganizationOptionsStart(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchOrganizationOptionsSuccess(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchOrganizationOptionsFailed(state, action)

    case actionTypes.FETCH_ASSIGNMENT_STATUS_OPTIONS_FOR_APPRAISAL_START:
      return fetchStatusOptionsStart(state, action)
    case actionTypes.FETCH_ASSIGNMENT_STATUS_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchStatusOptionsSuccess(state, action)
    case actionTypes.FETCH_ASSIGNMENT_STATUS_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchStatusOptionsFailed(state, action)

    case actionTypes.FETCH_ASSIGNMENT_DATA_START:
      return fetchAssignmentsStart(state, action)
    case actionTypes.FETCH_ASSIGNMENT_DATA_SUCCESS:
      return fetchAssignmentsSuccess(state, action)
    case actionTypes.FETCH_ASSIGNMENT_DATA_FAILED:
      return fetchAssignmentsFailed(state, action)

    case actionTypes.DELETE_APPRAISAL_ITEM_START:
      return deleteAssignmentStart(state, action)
    case actionTypes.DELETE_APPRAISAL_ITEM_SUCCESS:
      return deleteAssignmentSuccess(state, action)
    case actionTypes.DELETE_APPRAISAL_ITEM_FAILED:
      return deleteAssignmentFailed(state, action)

    case actionTypes.IMPORT_ASSIGNMENT_START:
      return importAssignmentStart(state, action)
    case actionTypes.IMPORT_ASSIGNMENT_SUCCESS:
      return importAssignmentSuccess(state, action)
    case actionTypes.IMPORT_ASSIGNMENT_FAILED:
      return importAssignmentFailed(state, action)

    case actionTypes.EXPORT_ASSIGNMENT_START:
      return exportAssignmentStart(state, action)
    case actionTypes.EXPORT_ASSIGNMENT_SUCCESS:
      return exportAssignmentSuccess(state, action)
    case actionTypes.EXPORT_ASSIGNMENT_FAILED:
      return exportAssignmentFailed(state, action)

    case actionTypes.CLEAR_FILTERED_ASSIGNMENT_RECORDS:
      return clearCorporateAssignmentRecord(state)

    case actionTypes.FETCH_TO_STAGE_START:
      return fetchToStageStart(state, action)
    case actionTypes.FETCH_TO_STAGE_SUCCESS:
      return fetchToStageSuccess(state, action)
    case actionTypes.FETCH_TO_STAGE_FAILED:
      return fetchToStageFailed(state, action)

    case actionTypes.BULK_UPDATE_ASSIGNMENT_START:
      return bulkUpdateAssignmentStart(state, action)
    case actionTypes.BULK_UPDATE_ASSIGNMENT_SUCCESS:
      return bulkUpdateAssignmentSuccess(state, action)
    case actionTypes.BULK_UPDATE_ASSIGNMENT_FAILED:
      return bulkUpdateAssignmentFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}
